import { useNavigate } from 'react-router-dom';
import { rooms } from '@/mocks/hotelData';

export default function RoomShowcase() {
  const navigate = useNavigate();
  const featuredRooms = rooms.slice(0, 3);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs md:text-sm text-primary-600 tracking-widest uppercase font-medium">
            Luxury Accommodations
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2 mb-3">
            精选房型推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            从豪华客房到总统套房，每一间客房都经过精心设计，融合东方典雅与西方奢华
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featuredRooms.map((room) => (
            <article
              key={room.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
              onClick={() => navigate('/category/rooms')}
            >
              <div className="relative h-56 md:h-64 overflow-hidden">
                <img
                  src={room.imageUrl}
                  alt={room.name}
                  title={`${room.name} - 新葡京酒店`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium rounded-full">
                    {room.category}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-1">{room.name}</h3>
                <p className="text-xs text-foreground-500 mb-3">{room.nameEn}</p>
                <div className="flex items-center gap-4 text-xs text-foreground-600 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-aspect-ratio-line text-sm"></i> {room.size}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-hotel-bed-line text-sm"></i> {room.bedType}
                  </span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">{room.description}</p>
                <div className="flex items-end justify-between">
                  <span className="font-heading text-lg font-bold text-primary-600">{room.price}</span>
                  <span className="text-xs text-primary-500 font-medium flex items-center gap-1 group-hover:gap-2 transition-all duration-200">
                    查看详情 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-10">
          <button
            onClick={() => navigate('/category/rooms')}
            className="px-8 py-3 border-2 border-primary-500 text-primary-600 font-medium rounded-lg hover:bg-primary-500 hover:text-background-50 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            查看全部房型
          </button>
        </div>
      </div>
    </section>
  );
}